import type { FeatureFlagObject } from "~/account/types/feature-flags";

const defaults = {
  // enable_{action}
  enable_join_team_flow: false,
  enable_login_as_user_flow: false,
  enable_tenant_organization_flow: false,
  enable_migrate_b2c_to_advantage: false,
  enable_purchase_breakdowns_flow: false,

  // enable_{entity}_{action}

  // Auth
  enable_auth_social_button_google: false,
  enable_auth_social_button_facebook: false,
  enable_auth_social_button_apple: false,
  enable_auth_change_password_disclaimer: false,

  // Event
  enable_event_team_stats_tab: false,
  enable_event_stats_export_to_pdf: false,
  enable_event_athlete_stats_tab: false,
  enable_event_add_lineup: false,
  enable_event_leaders: false,
  enable_team_leaders: false,
  enable_telestration_mode: false,
  enable_event_stats_export_to_csv: false,
  enable_event_stats_export_to_maxpreps: false,
  enable_event_edit_details_non_canonical: false,
  enable_event_edit_details_canonical: false,
  enable_event_playlists_athletes_filter: false,
  enable_event_logging_status_filter: false,
  enable_event_shared_external_events: false,
  enable_event_download_video_without_login: false,
  enable_event_share_downloadable_files: false,
  enable_event_share_specific_angles: false,
  enable_event_move_events_to_another_athlete_flow: false,
  enable_event_select_exchange: false,
  enable_event_send_breakdown: false,

  // Team
  enable_team_manage_rosters_vs_deep_link: false,
  enable_team_overview_tab: false,
  enable_team_stats_tab: false,
  enable_team_roster_stats_tab: false,
  enable_team_create_subscription_upgrade_modal: false,
  enable_team_athletes_tab: false,
  enable_team_video_upload: false,
  enable_team_video_upload_multiple_files_per_angle: false,
  enable_team_video_upload_multiple_angles: false,
  enable_team_video_upload_scout: false,
  enable_team_video_import_replay: false,
  enable_team_video_import: false,
  enable_team_athlete_import_from_prev_season: false,

  // League
  enable_league_standings_tab: false,
  enable_league_leaderboards_tab: false,
  enable_league_athletes_tab: false,

  // Athlete
  enable_athletes_index_page: false,
  enable_athletes_create_page: false,
  enable_athletes_edit_page: false,
  enable_athletes_delete: false,
  enable_athlete_overview_tab: false,
  enable_athlete_bio_tab: false,
  enable_athlete_videos_tab: false,
  enable_athlete_stats_tab: false,
  enable_athlete_charts_tab: false,
  enable_athletes_merge: false,
  enable_athletes_export_to_another_season: false,

  // Review
  enable_reviews: false,
  enable_review_report: false,

  // User management
  enable_user_management: false,
  enable_switch_to_user: false,
  enable_manage_tenant: false,

  // Coaching tools
  enable_custom_tags: false,

  // Onboarding
  enable_you_onboarding_redirect: false,

  // Account menu
  enable_account_subscriptions: false,
  enable_account_orders: false,
  enable_account_breakdowns: false,

  // Video player
  enable_video_player_clipped_type_event: false,
};

export type FeatureFlagKey = keyof typeof defaults;

export const defaultFeatureFlags = defaults as FeatureFlagObject;
